var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.0459,
    height: 22.0459,
    rx: 2.19,
    fill: "#FFC814"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5166 11.061V8.48284C4.5166 6.91812 4.5166 6.13577 5.0027 5.64967C5.48879 5.16357 6.27115 5.16357 7.83587 5.16357H8.19666C8.87504 5.16357 9.21423 5.16357 9.51922 5.28991C9.82421 5.41624 10.0641 5.65608 10.5437 6.13577L11.1268 6.71886C11.6065 7.19854 11.8464 7.43838 12.1513 7.56471C12.4563 7.69105 12.7955 7.69105 13.4739 7.69105H14.6772C16.2419 7.69105 17.0243 7.69105 17.5104 8.17714C17.9965 8.66324 17.9965 9.4456 17.9965 11.0103V13.6392C17.9965 15.2039 17.9965 15.9863 17.5104 16.4723C17.0243 16.9584 16.2419 16.9584 14.6772 16.9584H13.784",
    stroke: "white",
    strokeWidth: 1.65963,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67432 14.8523H11.2567M11.2567 14.8523L8.30802 11.9036M11.2567 14.8523L8.30802 17.801",
    stroke: "#0096FF",
    strokeWidth: 1.65963,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.b1dd16a76bc03d57296b1b16736af6f5.svg";
export { ForwardRef as ReactComponent };